import SlimSelect from 'slim-select'

export default class Contact {
  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')
    if (!this.form) return

    this.mailer = '/wp-content/themes/bimet/mailer/send-mail.php'

    this.bindCheckboxes()
    this.bindSubmit()

    this.initSelect()
  }

  initSelect() {
    this.select = new SlimSelect({
      select: this.form.querySelector('.contact--select'),
      settings: {
        allowDeselect: true,
        searchPlaceholder: 'Rechercher',
      },
    })

    // Empêche Lenis d'intercepter le wheel pour laisser scroller le dropdown
    const content = this.select.render?.content?.main
    if (content) content.setAttribute('data-lenis-prevent', '')
  }

  bindCheckboxes() {
    this.el.querySelectorAll('.contact--checkbox-container').forEach(container => {
      container.addEventListener('click', () => {
        const checkbox = container.querySelector('.contact--input-checkbox')
        checkbox.checked = !checkbox.checked
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      const options = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }

      this.setState('loading')

      fetch(this.mailer, options)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok')
          return response
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.setState('sent')

          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })

    this.form.querySelectorAll('.contact--submit.is-loading, .contact--submit.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault())
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.contact--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }

}
